import GradientTemperatureValid from './GradientTemperatureValid';

export default class GradientTemperature384 extends GradientTemperatureValid {
  constructor(rowIndex: number, temperature: number) {
    super(rowIndex, temperature, 16);
  }
}
